var React = require('react');

function LoadingIndicator (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#808080","fillRule":"evenodd","clipRule":"evenodd"},[React.createElement("path",{"d":"M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8z","opacity":".5","key":0}),React.createElement("path",{"d":"M7.25.75A.75.75 0 018 0a8 8 0 018 8 .75.75 0 01-1.5 0A6.5 6.5 0 008 1.5a.75.75 0 01-.75-.75z","key":1})]));
}

LoadingIndicator.defaultProps = {"width":"288","height":"199","viewBox":"0 0 16 16","fill":"none","className":"hds-flight-icon--animation-loading"};

module.exports = LoadingIndicator;

LoadingIndicator.default = LoadingIndicator;
